import Immutable from 'immutable';
import {prevIndexUpdater, nextIndexUpdater} from 'store/utils';
import {ActionTypes} from './actions';

export const queryMinLength = 2;

export const initial = Immutable.fromJS({
    focus: false,
    query: '',
    suggesting: false,
    suggestions: [],
    suggestionIndex: -1,
    results: [],
    resultIndex: -1,
});

export const reducer = (state = initial, action) => {
    switch (action.type) {
        case ActionTypes.SET_FOCUS:
            return state.set('focus', action.focus);

        case ActionTypes.SET_QUERY:
            return state.merge({
                query: action.query,
                suggesting: action.query.length >= queryMinLength,
                suggestions: action.suggestions,
                suggestionIndex: -1,
                results: [],
                resultIndex: -1,
            });

        case ActionTypes.SET_RESULTS:
            return state.merge({
                query: action.query,
                suggesting: false,
                suggestions: [],
                suggestionIndex: -1,
                results: action.results,
                resultIndex: -1,
            });

        case ActionTypes.SET_RESULT_INDEX:
            return state.set('resultIndex', action.index);

        case ActionTypes.PREV_RESULT:
            return state.update(prevIndexUpdater('results', 'resultIndex'));

        case ActionTypes.NEXT_RESULT:
            return state.update(nextIndexUpdater('results', 'resultIndex'));

        case ActionTypes.SET_SUGGESTION:
            return state.set('suggestionIndex', action.index);

        case ActionTypes.PREV_SUGGESTION:
            return state.update(prevIndexUpdater('suggestions', 'suggestionIndex', {reset: true}));

        case ActionTypes.NEXT_SUGGESTION:
            return state.update(nextIndexUpdater('suggestions', 'suggestionIndex', {reset: true}));

        case ActionTypes.CLEAR:
            return initial;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./scripts/store/search/reducer.js